import {combineReducers, Reducer} from "redux";
import {createLoadDataReducer, LoadDataState} from "../common/util/asyncdata/reducerUtil";
import {AOIMonitor as Notification} from "./model";
import {notificationReducerUtil} from "./reducerUtil";
import {actionTypes, LOAD_NOTIFICATION_DETAIL_PREFIX, LOAD_NOTIFICATIONS_PREFIX} from "./actions";
import {moduleName} from "./selectors";

export interface ByIdState {
    [id: string]: Notification;
}

export type AllIdState = string[];

export interface NotificationState {
    byId: ByIdState;
    allIds: AllIdState;
    loadNotificationsRequest: LoadDataState<Notification[]>;
    loadNotificationDetailRequest: LoadDataState<Notification>;
    currentNotificationId?: string;
}

const notificationByIdReducer = (state: ByIdState = {}, action): ByIdState => {
    switch (action.type) {
        case actionTypes.LOAD_NOTIFICATION_DETAIL_SUCCESS:
            return notificationReducerUtil.loadNotificationDetailForNotificationByIdReducer(state, action);
        case actionTypes.LOAD_NOTIFICATIONS_SUCCESS:
            return notificationReducerUtil.loadNotificationsSuccessForNotificationByIdReducer(state, action);
        case actionTypes.ADD_NOTIFICATION:
            return notificationReducerUtil.updateNotificationActionForNotificationByIdReducer(state, action);
        case actionTypes.REMOVE_NOTIFICATION:
            return notificationReducerUtil.deleteNotificationForNotificationByIdReducer(state, action);
        case actionTypes.PROGRESS_NOTIFICATION:
            return notificationReducerUtil.updateNotificationForNotificationByIdReducer(state, action);
        default:
            return state;
    }
};

const allIdReducer = (state: AllIdState = [], action): AllIdState => {
    switch (action.type) {
        case actionTypes.LOAD_NOTIFICATIONS_SUCCESS:
            return notificationReducerUtil.loadNotificationsSuccessForAllIdReducer(state, action);
        case actionTypes.ADD_NOTIFICATION:
            return notificationReducerUtil.addNotificationForAllIdReducer(state, action);
        case actionTypes.REMOVE_NOTIFICATION:
            return notificationReducerUtil.removeNotificationForAllIdReducer(state, action);
        default:
            return state;
    }
};

const loadNotificationRequestReducer = createLoadDataReducer<Notification[]>(LOAD_NOTIFICATIONS_PREFIX, []);
const loadNotificationDetailRequestReducer = createLoadDataReducer<Notification>(LOAD_NOTIFICATION_DETAIL_PREFIX, null);

function currentNotificationReducer(state = "", action) {
    if(action.type === actionTypes.LOAD_NOTIFICATION_DETAIL_SUCCESS){
        return action.payload.id;
    }
    return state;
}

const reducer: Reducer<NotificationState> = combineReducers<NotificationState>({
    byId: notificationByIdReducer,
    allIds: allIdReducer,
    loadNotificationsRequest: loadNotificationRequestReducer,
    loadNotificationDetailRequest: loadNotificationDetailRequestReducer,
    currentNotificationId: currentNotificationReducer,
});

export {
    moduleName,
    reducer,
};